module.exports = __webpack_public_path__ + "img/paige-carmichael-teaching.cce5c465.jpg";